import * as React from "react"
import { Box, BoxProps } from "@chakra-ui/react"

export const Limiter: React.FC<BoxProps & { size?: "sm" | "md" | "lg" }> = ({ size = "md", ...props }) => {
  const px = {
    base: 4,
    md: 8,
    lg: 18,
    xl: size === "sm" ? 18 : size === "md" ? 24 : 48,
  }
  return <Box w="100%" px={px} {...props} />
}
